module.exports = __webpack_public_path__ + "static/media/29.4886b8ed.jpeg";